<template>
  <!--el-submenu改名为el-sub-menu-->
  <div class="menu">
    <el-row class="tac">
      <el-col :span="12">
        <el-menu
          class="el-menu-vertical-demo"
          ref="menus"
          @open="handleOpen"
          @close="handleClose"
          :collapse="isCollapse"
          background-color="transparent"
          text-color="#ffffff"
          active-text-color="#00EBF4"
          :default-openeds="openeds"
          :router='true'
          :default-active="onRoutes"
          >
          <!-- :default-openeds="openeds" -->
          <!-- 有多级菜单 -->
          <template v-for="item in items">
            <template v-if="item.subs">
              <el-submenu :index="item.index+''" :key="item.index">
                <!-- 一级菜单 -->
                <template slot="title"  >
                <i :class="item.icon"></i>
                <span slot="title">{{item.title}}</span>
                </template>
                <!-- 二级菜单 -->
                <template v-for="subItem in item.subs" >
                  <!-- <el-submenu v-if="subItem.subs" :index="subItem.index+''" :key="subItem.index">
                    <template slot="title">{{subItem.title}}</template> -->
                    <!-- 三级菜单 -->
                    <!-- <el-menu-item v-for="(threeItem,i) in subItem.subs" :key="i" :index="threeItem.index" >
                      {{threeItem.title}}
                      <span style="width: 100%;height: 1px;background-color: #fff;"></span>
                    </el-menu-item> -->
                  <!-- </el-submenu> -->
                  <el-menu-item :index="subItem.index+''" :key="subItem.index">
                    {{subItem.title}}
                  </el-menu-item>
                </template>
              </el-submenu>
            </template>
            <!-- 只有一级菜单 -->
            <template v-else>
              <el-menu-item :index="item.index+''" :key="item.index">
                <i :class="item.icon"></i>
                <span slot="title">{{item.title}}</span>
              </el-menu-item>
            </template>
          </template>
        </el-menu>
      </el-col>
    </el-row>
  </div>

</template>

<style lang="scss" scoped>
  .menu{
    display: flex;
    flex-direction: column;
  }

</style>

<script>
  import {permissionCheckUtil} from '../../utils/permission.js'

  export default {
    name: "MenuTree",
    data() {
      return {
        isCollapse: false,
        openeds:['/data','/monitor/','/manage/','/index/','/system/'],
        uniqueOpened:false,
        items:[]
      };
    },
    computed:{
      onRoutes(){

        const route = this.$route;
        const {meta,path} = route;

        if(meta.activeMenu){
          return meta.activeMenu;
        }

        return path;
      }
    },
    methods: {
      handleOpen(key, keyPath) {
      },
      handleClose(key, keyPath) {
      },
      handleMenus(){
        var token = localStorage.getItem('token');
        if(token.length>0){
          //数据分析
          let map1 = permissionCheckUtil.findName("statistics:map")

          // 设备监控，耗材告警
          let monitor1 = permissionCheckUtil.findName("equipment:maintain");
          let monitor2 = permissionCheckUtil.findName("consumable:alert");

          // 内容管理
          // 1.设备管理
          let equipment1 = permissionCheckUtil.findName("equipment:read");
          let equipment2 = permissionCheckUtil.findName("equipment:readSeveral");

          // 2.耗材管理
          let consumables1 = permissionCheckUtil.findName("consumable:readUsed");
          let consumables2 = permissionCheckUtil.findName("consumable:readInventory");
          let consumables3 = permissionCheckUtil.findName("consumable:create");

          // 3.账号管理
          let account1 = permissionCheckUtil.findName("account:read");

          // 4.分组管理
          let group1 = permissionCheckUtil.findName("accountgroup:read");

          // 5.识别码管理
          let code1 = permissionCheckUtil.findName("typecode:read");

          // 6.知识库管理
          let knowledge1 = permissionCheckUtil.findName("knowledge:read");

          // 7.访问控制管理
          let control1 = permissionCheckUtil.findName("system:accessControl");

          // 日志
          let log1 = permissionCheckUtil.findName("system:log");

            var array = [];

            //1.数据分析
            // if(map1 == true){
            //   array.push({
            //     icon: 'el-icon-s-home',
            //     index: '/data',
            //     title: '数据分析'
            //   })
            // }

            //2.监控告警
            var tempArr1 = []
            //2.1设备监控
            if(monitor1==true){
              tempArr1.push({
                index: '/monitor/equipment/equipment-monitor',
                title: '设备监控',
              })
            }
            //2.2耗材告警
            if(monitor2==true){
              tempArr1.push({
                index: '/monitor/consumables/consumables-monitor',
                title: '耗材告警'
              })
            }

            if(tempArr1.length == 1){
              var obj = tempArr1[0]
              if(obj.title === '设备监控'){
                array.push({
                  icon: 'el-icon-warning',
                  title: '设备监控',
                  index:'/monitor/equipment/equipment-monitor'
                })
              }else{
                array.push({
                  icon: 'el-icon-warning',
                  title: '耗材告警',
                  index:'/monitor/consumables/consumables-monitor'
                })
              }
            }else if(tempArr1.length == 2){
              array.push({
                icon: 'el-icon-warning',
                title: '监控告警',
                subs:tempArr1
              })
            }

            //3.内容管理
            var tempArray2 = [];
            //3.1设备管理
            if (equipment1==true || equipment2==true) {
              tempArray2.push({
                icon: 'el-icon-s-grid',
                title: '设备管理',
                index:'/manage/equipment/equipment-list'
              })
            }

            //3.2耗材管理
            if (consumables1==true || consumables2==true || consumables3==true || monitor2==true) {
              tempArray2.push({
                icon: 'el-icon-s-grid',
                title: '耗材管理',
                index:'/manage/consumables/consumables-list'
              })
            }

            //3.3账号管理
            if(account1==true){
              tempArray2.push({
                icon: 'el-icon-s-grid',
                title: '账号管理',
                index:'/manage/user/user-list'
              })
            }
            //3.4分组管理
            if(group1==true){
              tempArray2.push({
                icon: 'el-icon-s-grid',
                title: '分组管理',
                index:'/manage/group/group-list'
              })
            }

            //3.5识别码管理
            if(code1==true){
              tempArray2.push({
                icon: 'el-icon-s-grid',
                title: '识别码管理',
                index:'/manage/rules/rules-list'
              })
            }

            //3.6知识库管理
            if(knowledge1==true){
              tempArray2.push({
                icon: 'el-icon-s-grid',
                title: '知识库管理',
                index:'/manage/knowledge/knowledge-list'
              })
            }

            // 3.7 IP管理
            if(control1==true){
              tempArray2.push({
                icon: 'el-icon-s-grid',
                title: '访问控制管理',
                index:'/manage/ip/ip-list'
              })
            }

            if(tempArray2.length>0){
              array.push({
                icon: 'el-icon-s-grid',
                title: '内容管理',
                subs: tempArray2
              })
            }

            // 4.系统服务
            var tempArray3 = []
            //4.1日志
            if(log1==true){
              tempArray3.push({
                title: '系统日志',
                index:'/system/log'
              })
            }

            //4.2用户手册
            tempArray3.push({
              title: '用户手册',
              index: '/system/manual',
            })

            //4.3建议反馈
            tempArray3.push({
              title: '建议反馈',
              index: '/system/feedback',
            })

            // 4.4消息提醒
              tempArray3.push({
                title: '消息提醒',
                index:'/system/news'
              })
              // 4.5关于系统
              tempArray3.push({
                title: '关于系统',
                index: '/system/about',
              })

            if(tempArray3.length>0){
              array.push({
                icon: 'el-icon-s-tools',
                title: '系统服务',
                subs: tempArray3
              })
            }

            array.push({
              icon: 'el-icon-s-custom',
              title: '个人中心',
              index:'/index'
            })

            this.items = array;
        }else{
            this.$router.replace('/login');
        }
      },
    },
    created() {
      // 1.权限判断
      var token = localStorage.getItem('token');
      if(token.length>0){
        this.handleMenus()
      }else{
        this.$router.replace('/login')
      }
    },
    mounted() {
    },
  }
</script>

<style  lang="scss" scoped>
  .item {
  margin-top: 0px;
}
</style>



// WEBPACK FOOTER //
// src/components/layout/menu-tree.vue